import type {PrimitiveType} from "../../../common/utils/objects";
import {eopCustomEvent} from "../../../common/utils/events";
import type {Nullable} from "../../../bootstrap/common/types";

export const CHECKBOX_EVENT = "eop-checkbox";
export const DROPDOWN_EVENT = "eop-dropdown";

export type CheckboxEvent<T extends PrimitiveType> = CustomEvent<CheckboxEventData<T>>;

export type CheckboxEventData<T extends PrimitiveType> = { inputId: string, inputValue: T };

export function checkboxEvent<T extends PrimitiveType>(inputId: string, inputValue: T): CheckboxEvent<T> {
    return eopCustomEvent(CHECKBOX_EVENT, {inputId: inputId, inputValue: inputValue});
}

export type DropdownEvent = CustomEvent<DropdownEventData>;

export type DropdownEventData = { value: string; label: Nullable<string>; };

export function dropdownEvent(value: string, label: string): DropdownEvent {
    return eopCustomEvent(DROPDOWN_EVENT, {value: value, label: label});
}